import {createAction} from "@reduxjs/toolkit";

export const setDetailGuestEvents = createAction('SET_DETAIL_GUEST_EVENTS');